// extracted by mini-css-extract-plugin
export var container = "SliderGroup-module__container___lF9s8";
export var label = "SliderGroup-module__label___jCnxh";
export var slider = "SliderGroup-module__slider___BpVuW";